import styled from "styled-components";

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
`
export const TableRow = styled.tr`
    border-top: 1px solid #dddddd;
    height: 50px;
    background-color: ${props => props.theme.hasError ? "#fef8f8" : props.theme.selected ? "#F8F8F8" : "white"};
    font-weight: ${props => props.theme.selected ? 700 : 500};
    &:last-child {
        border-bottom: 1px solid #dddddd;
    }
`
export const TableColumn = styled.td`
    padding: 0 10px 0 10px;
`

export const NestedTableTabSelectionColumn = styled.td.attrs({colSpan: 10})`
    display: flex;
    padding: 0 10px 0 10px;
    &:first-child {
        padding-left: 40px;
    }
`

interface NestedTableTabButtonProps {
    theme: any;
    customerTheme: any;
}

export const NestedTableTabButton = styled.button<NestedTableTabButtonProps>`
    margin: 10px 10px 10px 0;
    height: 46px;
    padding: 0 20px;
    border: solid 2px ${props => props.customerTheme.brandColor1};
    border-radius: 100px;
    background-color: ${props => props.theme.active ? props.customerTheme.brandColor1 : "white"};
    color: ${props => props.theme.active ? "white" : props.customerTheme.brandColor1};
    font-size: 15px;
    font-weight: 700;
    border-style: solid;
`
export const NestedTableRow = styled.tr`
    border: none;
`
export const NestedTableColumn = styled.td`
    padding: 0 10px 0 10px;
    &:first-child {
        padding-left: 40px;
    }
`
export const NestedTableIconButton = styled.button`
    background-color: ${props => props.theme.selected ? "#F8F8F8" : "white"};
    border: none;
    padding-right: 15px;
`